const smallScreenInput = {
  controlHeightLG: 46,
  borderRadiusLG: 6,
  colorBorder: "#000",
  lineWidth: 1,
  colorText: "#000",
  fontSize: 16,
  lineHeight: 1.2,
};

// Define your theme for larger screens (from previous example)
const largeScreenInput = {
  controlHeightLG: 56,
  // paddingBlockLG: 9,
  // paddingInlineLG: 20,
  borderRadiusLG: 12,
  fontSize: 16,
  lineHeight: 1.2,
  colorText: "#000",
  colorBorder: "#000",
};
const antDTokens = {
  token: {
    fontFamily: `'Poppins', sans-serif !important`,
    colorPrimary: "#00B86A",
    colorLink: "#00B86A",
  },
};
const antDTheme = {
  ...antDTokens,
  components: {
    Input: {
      ...largeScreenInput,
      colorBorder: "#D9D9D9",
      hoverBorderColor: "#4096FF",
    },
    Form: {
      labelColor: "#000",
      labelFontSize: "20px",
      labelFontWeight: 500,
      lanelLineHeight: "120%",
      labelFont: "Poppins",
    },
    Tag: {
      defaultBg: "#FFFBEB",
      defaultColor: "#D97706",
      padding: "12px",
    },
    Button: {
      fontWeight: 600,
      colorPrimary: "#00b86a",
      colorPrimaryHover: "#00b86a",
      colorPrimaryActive: "#00b86a",
    },
  },
};

const antDMobileTheme = {
  ...antDTokens,
  components: {
    Input: {
      ...smallScreenInput,
      colorBorder: "#D9D9D9",
      hoverBorderColor: "#4096FF",
    },
    Form: {
      labelColor: "#000",
      labelFontSize: "16px",
      labelFontWeight: 500,
      lanelLineHeight: "120%",
    },
    Tag: {
      defaultBg: "#FFFBEB",
      defaultColor: "#D97706",
      padding: "12px",
    },
    Button: {
      fontWeight: 600,
      colorPrimary: "#00b86a",
      colorPrimaryHover: "#00b86a",
      colorPrimaryActive: "#00b86a",
    },
  },
};

export { antDTheme, antDMobileTheme };
